module.exports = __webpack_public_path__ + "static/media/mode-537.25a05e10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-537.svg
// module id = 1055
// module chunks = 2